<template>
  <VueSidePanel
      v-model="isOpened"
      width="600px"
      transition-name="slide-right">
    <div class="events-list">
      <DataGrid v-if="isOpened"
                class="mr-0 fit-content event-data-grid"
                :data-model="dataGridModel"
                :data="events"
                :interactive="false"
                :showActionsTableHeader="false"/>
    </div>
    <button v-if="isOpened"
            class="clear-button"
            @click="clearEvents">
      {{ $t('generic.clear') }}
    </button>
  </VueSidePanel>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import DataGrid from "@/components/pages/partials/DataGrid.vue";
import {dataManipulator, entityDataManager, GoogleMapsManager} from "@/assets/js/data-manipulation";
import {VueSidePanel} from "vue3-side-panel";
import {ref} from "vue";
import {actions, mutations} from "@/assets/js/vue/vuex/actions";
import {EventSeverity} from "@/assets/js/events-info";

export default {
  name: "EventsList",
  components: {VueSidePanel, DataGrid},
  data() {
    return {
      isOpened: ref(false)
    };
  },
  computed: {
    ...mapState(['events', 'vehicles', 'eventsPanelOpened']),
    ... mapGetters(['allGeoFences']),
    dataGridModel() {
      return {
        headers: {
          ['']: 'icon',
          [this.$t('reports.events.result.date')]: 'date',
          [this.$t('reports.events.vehicle')]: 'name',
          [this.$t('reports.events.result.message')]: 'message',
        },
        values: {
          icon: this.getIcon,
          date: this.getEventDate,
          name: this.getVehicleName,
          message: this.getMessage
        },
        actions: [
          {icon: 'bi bi-geo-alt-fill text-danger font-size-24', buttonClass: 'border-less', handler: this.getEventLocation},
        ]
      };
    },
  },
  methods: {
    getIcon(event) {
      const result = {class: 'width-15', message: ''};

      const eventInfo = entityDataManager.getEventInfo(event.type, event.attributes?.alarm);
      if (eventInfo.severity >= EventSeverity.warning) {
        result.icon = 'bi bi-exclamation-circle-fill font-size-24 text-danger';
      }

      return result;
    },
    getEventDate(event) {
      return dataManipulator.iso8601DateStringToLocalMoment(event.eventTime)
          .format(this.$t('settings.generic.date-time-format-moment-extended'));
    },
    getVehicleName(event) {
      const device = entityDataManager.getVehicleByDeviceId(this.vehicles, event.deviceId);
      return device?.nickname ?? '';
    },
    getMessage(event) {
      const geoFenceName = entityDataManager.getGeoFenceName(event.geofenceId, this.allGeoFences);
      return entityDataManager.getTranslatedMessageByEvent(event.type, event.attributes?.alarm, geoFenceName, event.maintenanceName);
    },
    async getEventLocation(event) {

      const result = await this.$store.dispatch(actions.GET_TRACCAR_POSITIONS, {id: event.positionId});
      if (result?.length <= 0) {
        return;
      }

      const position = result[0];
      if (!position) {
        return;
      }

      GoogleMapsManager.openLocationLink(position.latitude, position.longitude);
    },
    clearEvents() {
      this.$store.commit(mutations.CLEAR_EVENTS);
    }
  },
  watch: {
    eventsPanelOpened(val) {
      this.isOpened = val;
    },
    isOpened(val) {
      this.$store.commit(mutations.TOGGLE_EVENTS_PANEL, val);
    }
  }
}
</script>

<style scoped lang="scss">

.events-list {
  .event-data-grid {
    max-height: calc(100vh - 120px) !important;
    height: calc(100vh - 120px) !important;
    padding-bottom: 20px !important;

    :deep(table) {
      th, td {
        &:nth-child(1) {
          width: 5% !important;
        }
        &:nth-child(2) {
          width: 15% !important;
        }
        &:nth-child(4) {
          width: 40% !important;
        }
        &:nth-child(5) {
          width: 6% !important;
        }
      }
    }
  }
}

.clear-button {
  float: right;
  margin-right: 20px;
  margin-bottom: 10px;
}

</style>